import React, { useState, useEffect } from "react";

import { Link, useHistory } from "react-router-dom";

import ProductTags from "../Tags/ProductTags";
import { longDate } from "../../utils/DateHelper";
// import ConfirmationModal from "../Modals/ConfirmationModal";
import { Trans, useTranslation } from "react-i18next";
import {
    LABSTORE_ACCESS,
    PRODUCT_TYPES,
    GLOBAL_ID,
} from "../../utils/constants";
import PriceOptionsCard from "../Cards/PriceOptionsCard";
import { isEmpty } from "lodash";
import PurchaseModal from "../Modals/PurchaseModal";
import LazyImage from "../Shared/LazyImage";
import { isLabstoreAuthorized } from "../../utils/RolesHelpers";
import { setObject } from "../../utils/StorageHelpers";
import BaseAlertModal from "../Modals/BaseAlertModal";
import PaymentModal from "../Modals/PaymentModal";
import Tippy from "@tippyjs/react";
import InformationTooltip from "../Tooltips/InformationTooltip";
import SimpleNotification from "../../components/Notifications/SimpleNotification";
import PromotionCodesAPI from "../../API/promotionCodes.api";
import MainLoadingButton from "../Buttons/MainLoadingButton";
import ValidationError from "../Shared/ValidationError";
// import paymentsAPI from "../../API/payments.api";

const ProductSpecsCard = ({
    model,
    parameters,
    handleSubscription,
    isSubscribing,
    isSubscribed,
    currentUser,
    productId,
    selectedPlan,
    setSelectedPlan,
    isPreview,
    promoCode,
    setPromoCode,
    includePromoCode,
    setIncludePromoCode,
    applyCodeVerification,
}) => {
    const [purchaseModalButton, setPurchaseModalButton] = useState(false);
    const [disclaimerModalButton, setDisclaimerModalButton] = useState(false);
    const [emailModal, setEmailModal] = useState(false);
    const [differentCountry, setDifferentCountry] = useState(false);
    const [paymentModalButton, setPaymentModalButton] = useState(false);
    const [subscribeButtonClicked, setSubscribeButtonClicked] = useState(false);
    const [isSubscriptionRequesting, setIsSubscriptionRequesting] =
        useState(false);
    const [clientSecret] = useState("");
    const [createdSubscription] = useState({});
    const [percentageDiscount, setPercentageDiscount] = useState("");
    const [addedParameters, setAddedParameters] = useState([]);
    const [isVerifyingPromoCode, setIsVerifyingPromoCode] = useState(false);

    const { t } = useTranslation();
    const history = useHistory();
    const isDefaultCurrencyEditable =
        currentUser.organization.isDefaultCurrencyEditable;

    useEffect(() => {
        if (!isSubscribed) {
            const countryId = currentUser.organization.supportedCountryId;
            //Search for the loggedin user in the product's supported countries
            const belongsToRegion =
                isEmpty(model?.supportedCountries) ||
                countryId === GLOBAL_ID ||
                model?.supportedCountries?.find(
                    ({ value }) => countryId === value
                );

            setDifferentCountry(!belongsToRegion);
        }
    }, []);

    useEffect(() => {
        if (applyCodeVerification) {
            applyPromoCode();
        }
    }, [applyCodeVerification]);

    const applyPromoCode = async () => {
        setIsVerifyingPromoCode(true);
        const result = await PromotionCodesAPI.getPromotionCodeOffer({
            promotionCode: promoCode,
            productId: model.id,
        });
        if (!isEmpty(result)) {
            setPercentageDiscount(result?.percentageDiscount);
            setAddedParameters(result?.parameters);
        }
        setIsVerifyingPromoCode(false);
    };

    const handlePromoCodeSwitch = () => {
        setIncludePromoCode((isIncludePromoCode) => {
            if (isIncludePromoCode) {
                setPercentageDiscount("");
                setAddedParameters([]);
            }
            return !isIncludePromoCode;
        });
    };

    const isPromoCodeInvalid = () => {
        return includePromoCode && !percentageDiscount;
    };

    const reset = () => {
        setPromoCode("");
        setPercentageDiscount("");
        setAddedParameters("");
    };

    const handleDisclaimerModal = () => {
        setSubscribeButtonClicked(true);

        if (isPromoCodeInvalid()) return;

        if (!currentUser.organization?.email) {
            setEmailModal(true);
        } else {
            differentCountry
                ? setDisclaimerModalButton(true)
                : handleSubscribeButton();
        }
    };

    const handleSubscribeButton = async () => {
        setDisclaimerModalButton(false);
        setPurchaseModalButton(true);
    };

    const isProductOwner = () => {
        const partnerId = currentUser?.organization?.partnerId;
        const userOrganizationId = currentUser?.organization?.id;
        const productOrganizationId = model?.developedBy?.id;
        return (
            partnerId === productOrganizationId ||
            userOrganizationId === productOrganizationId
        );
    };

    const renderSubscribeButton = () => {
        if (isEmpty(model?.subscriptionPlans)) return;

        if (isSubscribed) {
            return (
                <Link to={"/subscribed-products"}>
                    <button
                        className="secondary-green-btn w-full"
                        onClick={() =>
                            setObject(
                                "subscription-model-filters",
                                { productName: model?.productName },
                                true
                            )
                        }
                        disabled={!productId || isPreview}
                    >
                        <Trans i18nKey="view">View</Trans>
                    </button>
                </Link>
            );
        }
        const unAllowedSubscription =
            isProductOwner() ||
            model.isBelongToSubscribedBundle ||
            typeof selectedPlan !== "number" ||
            !isLabstoreAuthorized(currentUser, LABSTORE_ACCESS.subscribe);

        const subscribeButton = (
            <button
                className={`default-orange-btn w-full ${
                    model?.hasTrial ? "mb-2.5" : ""
                }`}
                onClick={handleDisclaimerModal}
                disabled={unAllowedSubscription || isPreview || isSubscribing}
            >
                {isSubscribing ? (
                    <>
                        <span className="animate-spin mr-3 inline-flex">
                            <i className="fas fa-sync" />
                        </span>
                        <Trans i18nKey="requesting">Requesting...</Trans>
                    </>
                ) : (
                    <span>
                        <Trans i18nKey="subscribe">Subscribe</Trans>
                    </span>
                )}
            </button>
        );

        const tippyMessage = () => {
            if (model.isBelongToSubscribedBundle) {
                return t("alreadyIncludedInSubscribedBundle");
            } else if (
                !isLabstoreAuthorized(currentUser, LABSTORE_ACCESS.subscribe)
            ) {
                return t("productViewerTooltip");
            } else if (isProductOwner()) {
                return t("productOwnerTooltip");
            } else return t("selectPlanTooltip");
        };

        return (
            <div className="flex flex-col items-end">
                {unAllowedSubscription && !isPreview ? (
                    <Tippy
                        content={tippyMessage()}
                        placement="bottom"
                        animation="scale"
                    >
                        <div className="w-full">{subscribeButton}</div>
                    </Tippy>
                ) : (
                    subscribeButton
                )}
                {model?.hasTrial && (
                    <div className="input-group m-0">
                        <label className="m-0">
                            {t("trialDaysMessage", {
                                days: model.trialDays,
                            })}
                        </label>
                    </div>
                )}
            </div>
        );
    };

    const isBundle = () => {
        return model?.type === PRODUCT_TYPES.bundle;
    };

    const getPrices = () => {
        return model?.subscriptionPlans.map((p) => ({
            name: p.durationType,
            price: p.price,
            currencyName: p.currencyName,
        }));
    };

    const submitSubscription = async () => {
        setIsSubscriptionRequesting(true);
        handleSubscription().then((response) => {
            if (!isEmpty(response)) {
                window.open(response, "_self");
                setIsSubscriptionRequesting(false);
            } else setIsSubscriptionRequesting(false);
        });
    };

    const getAddedParameters = () => {
        return (
            !isEmpty(addedParameters) && (
                <>
                    <div className="w-4 h-4 rounded-full border border-primary-color-orange relative flex justify-center items-center">
                        <i className="fas fa-plus fa-xs absolute text-primary-color-orange"></i>
                    </div>
                    <ProductTags
                        tags={addedParameters}
                        listClassName="green-tags"
                    />
                </>
            )
        );
    };

    const renderPromoCodeDetailsSection = () => {
        if (!includePromoCode) return;

        return (
            <div className="flex items-center">
                <div className="flex w-full">
                    <input
                        className="input-element"
                        name="promoCode"
                        readOnly={percentageDiscount}
                        value={promoCode || ""}
                        onChange={(e) => setPromoCode(e.target.value)}
                    />
                    {promoCode && (
                        <i
                            className={
                                "fas fa-times -ml-6 mt-auto mb-auto cursor-pointer text-gray-500"
                            }
                            onClick={reset}
                        ></i>
                    )}
                </div>
                <div className="ml-2">
                    <MainLoadingButton
                        buttonStyle="secondary-green-btn mng-model modal-btn-open"
                        isRequesting={isVerifyingPromoCode}
                        isDisabled={!promoCode || percentageDiscount}
                        buttonText={
                            percentageDiscount ? t("applied") : t("apply")
                        }
                        iconClassName={percentageDiscount ? "fas fa-check" : ""}
                        onClick={applyPromoCode}
                    />
                </div>
            </div>
        );
    };

    const renderPromoCodeSection = () => {
        if (isPreview || isProductOwner() || isSubscribed) return;
        return (
            <div className="input-group mt-3 mb-0">
                <div className="flex justify-between w-full">
                    <label className="uppercase text-xs">
                        {t("promotionCode")}
                    </label>
                    <div className="relative mr-3">
                        <input
                            type="checkbox"
                            className="sr-only"
                            checked={includePromoCode}
                            readOnly
                        />
                        <div className="w-10 h-4 bg-gray-100 rounded-full shadow-inner"></div>
                        <div
                            className="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition cursor-pointer"
                            onClick={handlePromoCodeSwitch}
                        ></div>
                    </div>
                </div>
                {renderPromoCodeDetailsSection()}
                <ValidationError
                    errorMessage={
                        isPromoCodeInvalid() &&
                        subscribeButtonClicked &&
                        t("inputPlaceholder", {
                            entity: t("promotionCode"),
                        })
                    }
                />
            </div>
        );
    };

    return (
        <>
            <div className="product-header card-table shadow relative mb-4">
                {model?.promoted && (
                    <LazyImage
                        src={
                            require("../../assets/images/special-price.png")
                                .default
                        }
                        className="img-special-price"
                        alt="Best Seller"
                    />
                )}
                {/* <div className="input-group">
                    <label className="uppercase">
                        <Trans i18nKey="downloads">Downloads</Trans>
                    </label>
                    <div className="status-number">{model?.numberOfDownloads}</div>
                </div> */}
                <div className="input-group">
                    <label className="uppercase">
                        <Trans i18nKey="type">Type</Trans>
                    </label>
                    {isBundle() ? (
                        <div className="tag-ele tag-bundle m-0 text-center">
                            {PRODUCT_TYPES.bundle}
                        </div>
                    ) : (
                        <div className="tag-ele tag-deployed m-0 text-center">
                            {PRODUCT_TYPES.model}
                        </div>
                    )}
                </div>
                <div className="input-group">
                    <label className="uppercase">
                        <Trans i18nKey="version">Version</Trans>
                    </label>
                    <div className="status-number">{model?.productVersion}</div>
                </div>
                <div className="input-group">
                    <label className="uppercase">
                        <Trans i18nKey="publishedAt">Published At</Trans>
                    </label>
                    <div className="status-number">
                        {longDate(model?.publishedAt)}
                    </div>
                </div>
                {!isBundle() && (
                    <div className="input-group">
                        <label className="uppercase">
                            <Trans i18nKey="parameters">Parameters</Trans>
                        </label>
                        <div className="flex items-center gap-1">
                            <ProductTags tags={parameters} />
                            {getAddedParameters()}
                        </div>
                    </div>
                )}
                <div className="input-group">
                    <label className="uppercase">
                        <Trans i18nKey="compatibleWith">Compatible With</Trans>
                    </label>
                    <ProductTags tags={model?.compatibleWith} />
                </div>
                {!isSubscribed && !isEmpty(model?.subscriptionPlans) && (
                    <div className="input-group">
                        <div className="flex">
                            <label className="uppercase">
                                <Trans i18nKey="price">Price</Trans>
                            </label>

                            {isDefaultCurrencyEditable && (
                                <InformationTooltip
                                    className="ml-1"
                                    message={t("currencyChangeInfoToolTip")}
                                />
                            )}
                        </div>
                        <PriceOptionsCard
                            selectedPlan={selectedPlan}
                            setSelectedPlan={setSelectedPlan}
                            pricePlans={getPrices()}
                            isPreview={isPreview}
                            currentUser={currentUser}
                            percentageDiscount={percentageDiscount}
                        />
                        {isPreview && (
                            <SimpleNotification
                                className="mt-2"
                                message={t("currencyChangableMessage")}
                            />
                        )}
                    </div>
                )}
                {renderSubscribeButton()}
                {renderPromoCodeSection()}
            </div>
            <BaseAlertModal
                isVisible={emailModal}
                setIsVisible={setEmailModal}
                title={t("missingData")}
                message={t("missingAffiliateData")}
                action={{
                    name: t("completeData"),
                    submitAction: () =>
                        history.push({
                            pathname: "/affiliate-profile",
                            state: {
                                isEdit: true,
                            },
                        }),
                }}
                type="warning"
            />
            <BaseAlertModal
                isVisible={disclaimerModalButton}
                setIsVisible={setDisclaimerModalButton}
                title={t("disclaimer")}
                message={t("differentCountryDisclaimer")}
                action={{
                    name: t("proceed"),
                    submitAction: handleSubscribeButton,
                }}
                type="warning"
            />
            <PaymentModal
                isVisible={paymentModalButton}
                setIsVisible={setPaymentModalButton}
                clientSecret={clientSecret}
                subscription={createdSubscription}
            />
            <PurchaseModal
                showModal={purchaseModalButton}
                setShowModal={setPurchaseModalButton}
                submitAction={submitSubscription}
                isSubmitting={isSubscriptionRequesting}
                model={model}
            />
        </>
    );
};

export default ProductSpecsCard;
